if(document.querySelector('.ProductItem .upsell-product-btn')) {
  document.querySelector('.ProductItem .upsell-product-btn').addEventListener('click',(event) => {
  (function(){
  let vid = event.target.getAttribute('data-vid');
  var addData = {
    'id':vid, /* for testing, change this to a variant ID on your store */
    'quantity':1
  };

  fetch('/cart/add.js', {
    body: JSON.stringify(addData),
    credentials: 'same-origin',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With':'xmlhttprequest' /* XMLHttpRequest is ok too, it's case insensitive */
    },
    method: 'POST'
  }).then(function(response) {
    return response.json();
  }).then(function(json) {
    /* we have JSON */
    console.log(json)
      updateME();
  }).catch(function(err) {
    /* uh oh, we have error. */
    console.error(err)
  });
  
})();
})  
}